import React from 'react';
import { useLocation } from 'react-router-dom';
import SocialLinks from './SocialLinks';
import './Footer.css';

const Footer = () => {
  const location = useLocation();
  const isAboutPage = location.pathname === '/about';

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-layout">
          <div className="footer-left">
            <div className="footer-links">
              <a href="/privacy-policy.html" target="_self" className="privacy-link">Privacy Policy</a>
              <a href="/terms-of-use.html" target="_self" className="terms-link">Terms of Use</a>
            </div>
            <div className="copyright">
              <span>© {new Date().getFullYear()} iOS Features Timeline. All rights reserved.</span>
            </div>
            <div className="analytics-notice">
              <span>We use anonymous analytics to understand page views, clicks, and overall site performance. No personal information is collected or stored.</span>
            </div>
          </div>
          <div className="footer-right">
            {isAboutPage ? (
              <SocialLinks className="footer-social-links" />
            ) : (
              <div className="footer-right-content">
                <SocialLinks className="footer-social-links" />
                <a href="/contribute" className="contribute-link">Contribute</a>
              </div>
            )}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;